import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { CustomSelect, CustomButton } from 'components/CustomForm';
import { Card, VDivider } from 'components/CommonWidgets';
import { useAdminSelector, useAdminDispatch } from 'admin-app/redux/admin.store';
import { useQuery } from 'react-query';
import {
	handleInputChange,
	buildFiltersQuery,
	handleUnionFilterChange,
	handleCompanyFilterChange,
	handleFilterTypeChange
} from 'admin-app/redux/reporting-filter.slice';
import {
	DefaultInputFilter,
	DateRadio,
	DefaultProvinceFilter,
	DefaultFilterType,
	SelfFilterType,
	DefaultCompanyFilter,
	DefaultUnionFilter
} from 'redux/global.consts';
import { getUnions, getProvinces } from 'network/apis/InformationApi';
import { getCorporations } from 'network/apis/CorporationApi';
import { getInputs } from 'network/apis/CommonApi';

const FilterTypeOptions = [
	DefaultFilterType,
	SelfFilterType,
	{ value: 0, label: 'شرکت های تعاونی' },
	{ value: 1, label: 'اتحادیه های استانی' }
];

const ResultBox = styled.div`
	display: grid;
	grid-template-rows: 1fr 1fr;
	row-gap: 0.5rem;

	& > div {
		display: grid;
		grid-template-columns: 1fr 1fr;
		text-align: center;
	}
`;

const Label = styled.span`
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;

const StoreReportHeader = ({ data, onDownloadProvinceExcel, onDownloadTableExcel }) => {
	const filterState = useAdminSelector((store) => store.reportingFilter);
	const dispatch = useAdminDispatch();

	const { data: inputsData } = useQuery(
		["get-inputs"],
		() => getInputs(),
		{
			refetchOnWindowFocus: false,
		}
	);
	const getInputOtions = () => {
		if (inputsData?.data) {
			const inputOptions = inputsData.data.map((input, index) => {
				return { value: input?.item_id, label: input?.name };
			});

			return [DefaultInputFilter, ...inputOptions];
		}

		return [];
	};

	const { data: corporationsData } = useQuery(
		["get-corporations"],
		() => getCorporations(),
		{
			refetchOnWindowFocus: false,
		}
	);
	const getCorporationsOptions = () => {
		if (corporationsData?.data) {
			const corporationsOptions = corporationsData.data.map((corporation, index) => {
				return { value: corporation?.coop_id, label: corporation?.name };
			});

			return [DefaultCompanyFilter, ...corporationsOptions];
		}

		return [];
	};

	const { data: unionsData } = useQuery(
		["get-unions"],
		() => getUnions(),
		{
			refetchOnWindowFocus: false,
		}
	);
	const getUnionsOptions = () => {
		if (unionsData?.data) {
			const unionsOptions = unionsData.data.map((union, index) => {
				return { value: union?.union_id, label: union?.name };
			});

			return [DefaultUnionFilter, ...unionsOptions];
		}

		return [];
	};

	const extraFilters = () => {
		switch (filterState.selectedFilterType.value) {
			case 0:
				return (
					<CustomSelect
						placeholder='همه شرکت ها'
						className={'w-50'}
						radius="14"
						options={getCorporationsOptions()}
						onChange={(newCorporation) => {
							dispatch(handleCompanyFilterChange(newCorporation));
							dispatch(buildFiltersQuery());
						}}
						value={filterState.selectedCompany}
						menuPosition='fixed'
					/>
				);
			case 1:
				return (
					<CustomSelect
						placeholder='همه اتحادیه ها'
						className={'w-50'}
						radius="14"
						options={getUnionsOptions()}
						onChange={(newUnion) => {
							dispatch(handleUnionFilterChange(newUnion));
							dispatch(buildFiltersQuery());
						}}
						value={filterState.selectedUnion}
						menuPosition='fixed'
					/>
				);
			default:
				return null;

		}
	};

	return (
		<Card className="d-flex justify-content-between align-items-center">
			<div className='ms-4 me-5 d-flex flex-column align-items-center gap-2'>
				<CustomButton
					fontSize={10}
					onClick={onDownloadTableExcel}
					color='#0278EE'
					className='w-100'
				>
					اکسل جدول
				</CustomButton>
				<CustomButton
					fontSize={10}
					onClick={onDownloadProvinceExcel}
					color='#0278EE'
					className='w-100'
				>
					اکسل استانی
				</CustomButton>
			</div>
			<VDivider />
			<ResultBox className="w-25">
				<div>
					<Label>{`${data?.count ?? 0}`.persianCurrency()}</Label>
					<Label>:انواع نهاده ها</Label>
				</div>
				<div>
					<Label>{`${data?.sum ?? 0}`.persianCurrency()}</Label>
					<Label>:مجموع(تن)</Label>
				</div>
			</ResultBox>
			<VDivider />
			<div className="ps-5 pe-2 w-75 d-flex justify-content-around align-items-center">
				{extraFilters()}
				<CustomSelect
					className="mx-2 w-50"
					radius="14"
					options={[...FilterTypeOptions]}
					onChange={(newFilter) => {
						dispatch(handleFilterTypeChange(newFilter));
						dispatch(buildFiltersQuery());
					}}
					value={filterState.selectedFilterType}
					menuPosition='fixed'
				/>
				<CustomSelect
					className="mx-2 w-50"
					radius="14"
					options={getInputOtions()}
					onChange={(newInput) => {
						dispatch(handleInputChange(newInput));
						dispatch(buildFiltersQuery());
					}}
					value={filterState.selectedInput}
					menuPosition='fixed'
				/>
			</div>
		</Card>
	);
};

export default StoreReportHeader;
